import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import { Header } from "../../components/header/header";
import { Footer } from "../../components/footer/footer";
import { useAuthentication } from "../../services/authentication/authentication.context";
import "../../styles/form.css";
import { AnimatedLoader } from "../../components/utilities/loader-anim";



export const AdminPage = () => {

    const [email, setEmail] = useState('');

    const [invalidData, setInvaliData] = useState([]);

    const { token, account, isAuthenticated } = useAuthentication();

   



    return (
        <div className="rand-page">
            <Header pageTitle={isAuthenticated ? "admin": "loading..."} />
            { isAuthenticated ?
                <div className="form-body">
                <form className="auth-form glassy-effect">
                    <div
                        className={classNames(
                            "auth-input-box",
                            { "invalid": invalidData.includes("email") }
                        )}
                    >
                        <FontAwesomeIcon icon={faUserAlt} className="input-ico" />
                        <input
                            type="text"
                            name="names"
                            onChange={(e) => setEmail(e.target.value)}
                            value={account?.user?.names}
                            disabled
                        />
                    </div>

                    <div
                        className={classNames(
                            "auth-input-box",
                            { "invalid": invalidData.includes("email") }
                        )}
                    >
                        <FontAwesomeIcon icon={faUserAlt} className="input-ico" />
                        <input
                            type="email"
                            name="email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={account?.user?.email}
                            disabled
                        />
                    </div>
                   

                    <button
                        className="form-submit"
                        onClick={async (e) => {
                            e.preventDefault();
                        }}
                    >
                        Update
                    </button>
                </form>
            </div>: <AnimatedLoader />}
            <Footer />
        </div>
    )
}